import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {SnackbarProvider} from 'notistack'
import {Column} from 'react-table'
import {ClaimUserDocument} from '../../../../model/claimUser.model'
import {ModalClaimDocuments} from '../modal/ModalClaimUserDocuments'
import {
  getClaimDocumentsService,
  downloadClaimDocumentsService,
} from '../../../../services/claimUser.service'
import {useCentral} from '../../../../../../hooks/useCentral'

const TableClaimDocuments: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModal, setShowModal] = useState(false)

  const handleNew = () => {
    setShowModal(true)
  }

  const getClaimDocuments = async () => {
    setLoading(true)
    const {data: response} = await getClaimDocumentsService(
      currentTabItem.idToEdit,
      pagination.currentPage,
    )
    if (!response.error) {
      setData(response.data)
      setPagination({
        ...pagination,
        totalResults: response.total,
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getClaimDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(false)
    getClaimDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const handleDownload = async (props: any) => {
    try {
      const getRow = props.row
      const getArrows = props.data
      const getData = getArrows[getRow.index]
      const response = await downloadClaimDocumentsService(getData.Id)
      const link = document.createElement('a')
      link.href = response.data.url
      link.download = getData.NombreDocumento + getData.TipoDocumento // Ajusta el nombre del archivo según tus necesidades

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }

  const columns: Column<ClaimUserDocument>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombre de Documento' />,
      accessor: 'NombreDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Documento' />,
      accessor: 'TipoDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tamaño de Documento' />,
      accessor: 'TamanoDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Registro' />,
      accessor: 'FechaRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Usuario de Registro' />,
      accessor: 'UsuarioRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('ADJDOCUMENTO/DESCARGAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleDownload(props)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-3' />
              </a>
            </div>
          )}{' '}
        </>
      ),
    },
  ]

  return (
    <>
      {isAllowed('ADJDOCUMENTO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('ADJDOCUMENTO/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          {showModal ? (
            <ModalClaimDocuments
              show={showModal}
              setShow={setShowModal}
              getClaimDocuments={getClaimDocuments}
            />
          ) : (
            <></>
          )}
          <SnackbarProvider />
        </KTCard>
      )}
    </>
  )
}

const TableClaimDocumentsWrapper = () => {
  return (
    <KTableProvider>
      <TableClaimDocuments />
    </KTableProvider>
  )
}

export {TableClaimDocumentsWrapper}
